//TODO: + write test for this util

export const formatDuration = (ms: number) => {
  let seconds = ms / 1000
  const time: Record<string, number> = { year: 31536000, day: 86400, hour: 3600, minute: 60, second: 1 }
  const res: string[] = []

  if (seconds === 0) return 'now'

  for (const key in time) {
    if (seconds >= time[key]) {
      let val: string = Math.floor(seconds / time[key]).toString()
      res.push((val += Number(val) > 1 ? ' ' + key + 's' : ' ' + key))
      seconds = seconds % time[key]
    }
  }

  return res.length > 1 ? res.join(', ').replace(/,([^,]*)$/, ' ' + '$1') : res[0]
}
